import React from "react";
import { Segment, Header } from "semantic-ui-react";

class MasterColegiosNuevo extends React.Component {
  render() {
    return (
      <Segment>
        <Header as="h3" content="Master Colegios Nuevo" />
      </Segment>
    );
  }
}

export default MasterColegiosNuevo;



// WEBPACK FOOTER //
// ./src/pages/colegios/MasterColegiosNuevo.jsx